module.exports = __webpack_public_path__ + "img/guest-access-old.5a54b2e7.webp";